import { InfinityIcon } from '../../../../assets/icons/infinityIcon'
import {
  InputScaleContainer,
  InputIndicatorScale,
  InfinityStyled,
  LittleText,
  Container,
} from '../IndicatorsAndSignals.style'
import { getScaleTypeColor } from '../../../subjects/Subject'
import { SignalLine } from '../../../../components/tables/main/indicators-signals-table/IndicatorsSignalTable.style'

const IndicatorScale = ({
  callback,
  signalsIds,
  scaleType,
}: {
  signalsIds: any
  callback: (data: any) => void
  scaleType: { name: string }
}) => {
  const handleSetSignal = ({ index, value }: any) => {

    const newScale = [ ...signalsIds || [] ]

    newScale[index] = {...newScale[index], valueFrom: value }

    console.log("qqqqq signalsIds",newScale, signalsIds, index);

    callback(newScale)
  }

  const signalColors = getScaleTypeColor(scaleType?.name || 'RAGAR')

  let isEditor = (global as any)?.isEditor;

  return (
    <Container>
      <InputScaleContainer data-animch>
        {signalColors.map((_color, index) => {
          
          const item: any = { ...signalsIds }[index] || {}
          let isLast = index === signalColors.length - 1;
          let color = _color.color;
          return (
            <><div key={index} style={{ display: 'flex', alignItems: 'center' }}>

              <InputIndicatorScale
                key={index}
                type={'number'}
                disabled={!isEditor}
                onChange={({ target: { value, name } }) => {
                  handleSetSignal({ index, name, value })
                }}
                color={color}
                placeholder={'Set value'}
                value={item?.valueFrom || ''}
              />
              <SignalLine color={color} />
              {isLast && <>
              <div style={{
              background: color,
               borderRadius: '50%', width: '38px', height: '38px', position: 'relative'}}>
                              <svg style={{    width:'24px',
    height: '24px',
    position: 'absolute',
    top: '7px',
    left: '7px',
}} viewBox="0 0 14 14" fill="none"
                          xmlns="http://www.w3.org/2000/svg">
              <mask id="mask0_590_2404" style={{"maskType":"alpha"}} maskUnits="userSpaceOnUse" x="0" y="3" width="14" height="8">
              <path d="M5.82977 8.31787L5.35399 8.85381C4.98746 9.2197 4.5207 9.46873 4.01268 9.56944C3.50467 9.67014 2.9782 9.618 2.49981 9.4196C2.02142 9.2212 1.61258 8.88544 1.32494 8.45476C1.03731 8.02408 0.883789 7.5178 0.883789 6.9999C0.883789 6.482 1.03731 5.97573 1.32494 5.54505C1.61258 5.11437 2.02142 4.77861 2.49981 4.58021C2.9782 4.38181 3.50467 4.32967 4.01268 4.43037C4.5207 4.53108 4.98746 4.78011 5.35399 5.146L8.64618 8.85381C9.01271 9.2197 9.47947 9.46873 9.98748 9.56944C10.4955 9.67014 11.022 9.618 11.5004 9.4196C11.9787 9.2212 12.3876 8.88544 12.6752 8.45476C12.9629 8.02408 13.1164 7.5178 13.1164 6.9999C13.1164 6.482 12.9629 5.97573 12.6752 5.54505C12.3876 5.11437 11.9787 4.77861 11.5004 4.58021C11.022 4.38181 10.4955 4.32967 9.98748 4.43037C9.47947 4.53108 9.01271 4.78011 8.64618 5.146L8.1704 5.68194" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </mask>
              <g mask="url(#mask0_590_2404)">
              <path d="M14 0H0V14H14V0Z" fill="#fff" />
              </g>
              </svg>
              </div>
              </>}

            </div>
            </>
          )
        })}
        {/*<InfinityStyled>*/}
        {/*  <InfinityIcon color='#fff' />*/}
        {/*</InfinityStyled>*/}
      </InputScaleContainer>
      <LittleText>
        Click on the input fields on this scale to fill the values
      </LittleText>
    </Container>
  )
}

export default IndicatorScale
